var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-container",class:{'basic-container--block':_vm.block},style:(_vm.styleName)},[_c('el-card',{staticClass:"basic-container__card"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }